import React from 'react'
import Habitacion from '../../models/Habitacion';
import GenerarModales from './GenerarModales';
import { getHabitaciones } from '../../services/HabitacionesService';

type Props = {
    habitaciones: Habitacion[]
}

const ModalesHabitaciones = ({habitaciones}: Props) => {

    return (
        <div id='modalesHabitaciones'>
            { GenerarModales(habitaciones) }
        </div>
    )
}

export default ModalesHabitaciones